<template>
  <FsDialog v-model="dialogVisible" title="Feedback" width="480px">
    <FsForm class="feedback_form" :model="model" :rules="rules" ref="formRef" horizontal v-if="!success">
      <FsFormItem prop="topic" label="Please select a topic for your feedback">
        <FsSelect new-regular v-model="model.topic" :options="options" />
      </FsFormItem>
      <FsFormItem prop="description" label="What's on your mind?">
        <FsInput
          new-regular
          v-model="model.description"
          :maxlength="1000"
          :show-number="true"
          type="textarea"
          placeholder="Your comments will help FS respond more quickly."
        >
        </FsInput>
      </FsFormItem>
      <p class="info">Would you like to talk more?Leave your email.</p>
      <!-- <FsFlex :gap="20"> -->
      <FsFormItem prop="name">
        <FsInput new-regular placeholder="Name" v-model="model.name" />
      </FsFormItem>
      <FsFormItem prop="email">
        <FsInput new-regular placeholder="Email address" v-model="model.email" />
      </FsFormItem>
      <!-- </FsFlex> -->
      <FsFormItem class="btn_box">
        <FsButton @click.prevent="submit" size="mediumSmall" type="red" style="margin-bottom: 10px" :loading="loading"
          >Submit</FsButton
        >
      </FsFormItem>
    </FsForm>

    <div class="success_box" v-else>
      <div class="success_icon">
        <i class="iconfont">&#xe710;</i>
      </div>
      <div class="success_tit">Feedback received!</div>
      <p class="success_txt">Thank you for taking time to tell us what you think.</p>
    </div>
  </FsDialog>
</template>

<script setup lang="ts">
import { ref, reactive, watch, onMounted } from 'vue'
import { FsDialog, FsForm, FsFlex, FsFormItem, FsButton, FsInput, FsSelect } from 'fs-design'
import { feedback } from '@/api/modules/user'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()

const { customersEmailAddress, customersFirstname, customersLastname } = storeToRefs(userStore)

const dialogVisible = ref<boolean>(false)
const options = reactive([
  { label: `Website Design`, value: `Website Design` },
  { label: `Search and Navigation`, value: `Search and Navigation` },
  { label: `Product`, value: `Product` },
  { label: `Checkout and Payment`, value: `Checkout and Payment` },
  { label: `Shipping and Delivery`, value: `Shipping and Delivery` },
  { label: `Return and Exchange`, value: `Return and Exchange` },
  { label: `Service and Support`, value: `Service and Support` },
  { label: `Website Suggestion`, value: `Website Suggestion` },
  { label: `Other`, value: `Other` },
])

const model = reactive({
  topic: options[0].value,
  description: '',
  name: '',
  email: '',
})

const success = ref<boolean>(false)
const loading = ref<boolean>(false)

const formRef = ref()

const rules = {
  topic: [
    {
      type: 'string',
      required: true,
      trigger: 'change',
      message: 'Please select a topic for your feedback.',
    },
  ],
  description: [
    {
      type: 'string',
      required: true,
      trigger: 'change',
      message: 'Please enter more than 10 characters.',
      min: 10,
    },
  ],
  name: [
    {
      type: 'string',
      required: true,
      trigger: 'blur',
      message: 'Name is required',
    },
  ],
  email: [
    {
      type: 'string',
      required: true,
      trigger: 'blur',
      message: 'Email is required',
    },
  ],
}

const submit = async () => {
  try {
    await formRef.value.validate()
    console.log('passed!')
    console.log(model)
    loading.value = true
    feedback({
      topic: model.topic,
      content: model.description,
      name: model.name,
      email: model.email,
    })
      .then(res => {
        loading.value = false
        success.value = true
      })
      .catch(err => {
        loading.value = false
      })
  } catch (e) {
    console.log('the promise', e)
  }
}
const showDialog = () => {
  dialogVisible.value = true
}
const reset = () => {
  formRef.value.resetFields()
}

const hideDialog = () => {
  dialogVisible.value = false
}

watch(
  [customersEmailAddress, customersFirstname, customersLastname],
  ([newEmail, newFirst, newLast], [oldEmail, oldFirst, oldLast]) => {
    console.log('Email changed:', oldEmail, '=>', newEmail)
    console.log('First name changed:', oldFirst, '=>', newFirst)
    console.log('Last name changed:', oldLast, '=>', newLast)
    model.name = `${newFirst} ${newLast}`
    model.email = `${newEmail}`
  }
)

onMounted(() => {
  console.log('______0409499')
})

defineExpose({
  showDialog,
  hideDialog,
})
</script>

<style lang="scss" scoped>
.feedback_form {
  :deep(.fs-textarea__number) {
    // display: none;
  }
}

.info {
  margin-bottom: 4px;
  color: #707070;
  @include font12;
}

.btn_box {
  margin-top: 20px;

  :deep(.fs-form__item--content) {
    display: flex;
    flex-direction: row-reverse;

    .fs-button {
      margin-left: 16px;
    }
  }
}

.success_box {
  margin: 0 auto;
  padding: 40px 0 100px 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .success_icon {
    margin-bottom: 16px;
    display: flex;
    justify-content: center;

    .iconfont {
      font-size: 50px;
      width: 50px;
      height: 50px;
      color: #10a300;
    }
  }

  .success_tit {
    @include font16;
    font-weight: 600;
    text-align: center;
    color: #19191a;
  }

  .success_txt {
    font-size: 16px;
    color: #19191a;
    text-align: center;
    font-weight: 600;
    max-width: 300px;
  }
}
</style>
